module.exports = __webpack_public_path__ + "static/master-c8194da37b0e87bc50252d69842a2fb9.jpg";